"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDBClient = void 0;
var documents_1 = require("./documents");
var collections_1 = require("./collections");
exports.AppDBClient = {
    DocumentsClient: documents_1.DocumentsClient,
    CollectionsClient: collections_1.CollectionsClient,
};
